import React from "react";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";

const ContentPage = ({ title, children }) => {
  const navigate = useNavigate();
  
  return (
    <Layout>
      <div className="min-h-[calc(100vh-8rem)] py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <button
            onClick={() => navigate(-1)}
            className="text-[#E8E4DC] hover:text-white mb-8 flex items-center gap-2 transition-colors"
            data-testid="back-button"
          >
            &larr; Back
          </button>
          
          <div className="card-glass p-8 md:p-12">
            <h1 className="font-heading text-4xl font-bold text-white mb-8" data-testid="page-title">
              {title}
            </h1>
            {children}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ContentPage;
